import { render, staticRenderFns } from "./event-management.vue?vue&type=template&id=4c227c5e&scoped=true&"
import script from "./event-management.vue?vue&type=script&lang=js&"
export * from "./event-management.vue?vue&type=script&lang=js&"
import style0 from "./event-management.vue?vue&type=style&index=0&id=4c227c5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c227c5e",
  null
  
)

export default component.exports